import { AxiosError } from 'axios';

export interface ApiErrorPayload<T = Record<string, string>> {
  message: string;
  errors?: T;
}

export type ApiError<T = Record<string, string>> = AxiosError<
  ApiErrorPayload<T>
>;

export const extractErrorMessage = (error: ApiError): string => {
  return error?.response?.data?.message ?? 'Unexpected server error';
};
